import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierLockModel/model.ts";
import "core-js/modules/es.array.map.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as api from '@gmini/sm-api-sdk';
import { createStore } from 'effector';
import { prop } from 'ramda';
export var createLockModel = function createLockModel(_ref) {
  var message = _ref.message;
  var lockMap$ = createStore({}, {
    name: "lockMap$",
    sid: "qvcuge"
  }).on(api.UserClassifier.fetchIsUserClassifierLocked.defaultContext.done, function (state, _ref2) {
    var id = _ref2.params.id,
        result = _ref2.result;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, id, result));
  }).on(message.map(prop('payload')), function (state, _ref3) {
    var id = _ref3.id,
        isLocked = _ref3.isLocked;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, id, isLocked));
  });
  return {
    lockMap$: lockMap$
  };
};